/**
 * Protected Route Component
 * Wraps routes that require authentication
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { Spinner, Flex, Text } from '@chakra-ui/react';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();

  // Show loading spinner while checking auth status
  if (isLoading) {
    return (
      <Flex
        height="100vh"
        width="100vw"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        gap={4}
      >
        <Spinner size="xl" color="brand.500" thickness="4px" />
        <Text fontSize="lg" color="gray.600">
          Checking authentication...
        </Text>
      </Flex>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/auth/sign-in/default" replace />;
  }

  // Render protected component if authenticated
  return children;
}
